import { Component, input } from '@angular/core';
import { SITE_DATA } from 'src/app/productization/default.constant';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { RouterLink } from '@angular/router';
@Component({
    selector: 'app-careers-life',
    templateUrl: './careers-life.component.html',
    styleUrls: ['./careers-life.component.scss'],
    imports: [NzGridModule, NzSpaceModule, NzButtonModule, RouterLink]
})
export class CareersLifeComponent {
	readonly countryOrigin = input<string | null>(null);
	public siteData = SITE_DATA;

	public addQueryParams(queryParams: any) {
		return { location: this.countryOrigin(), ...queryParams };
	}
}
